import { useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import SearchArea from "./area/search";
import ListArea from "./area/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";

function WordInsideReqListArea(props: any) {
  let myProps = {
    ...props
  };
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);
  const [listOpt, setListOpt] = useState({
    'now_page': 1,
    'num_per_page': 30,
    'order_id': 'a_title',
    'order_type': '',
    's_date_type': '',
    's_start_date': '',
    's_end_date': '',

    s_except_seq: "",
    s_title_like: "",
    s_word_type: "",
    s_addon_study_word: "1",
    s_addon_use: "1",
    s_addon_use_s_stu_seq: "",
  });
  const [infoArr, setInfoArr] = useState<any>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [is_show_pre_exist, set_is_show_pre_exist] = useState(false);

  useEffect(() => {
    if (is_show_pre_exist == false) {
      get_pre_use_arr_by_ajax();
    } else {
      list({ s_except_seq: "" });
    }
  }, [user.comp_seq]);

  const get_pre_use_arr_by_ajax = () => {
    let form_json_data: any = {
      s_stu_mcomp_seq: user.comp_seq,
      s_stu_seq: user.user_seq,
      is_paging: "",
    };
    if (strFunc.is_empty(form_json_data.s_stu_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(form_json_data.s_stu_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_use/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let s_except_seq_arr: any = [];
          if (response.data["data"]["info_arr"]) {
            for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
              s_except_seq_arr.push(response.data["data"]["info_arr"][i]["a_in_seq"]);
            }
          }
          list({
            s_except_seq: s_except_seq_arr
          });
        } else {

        }
      });
  };

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    tmp_listOpt.s_mcomp_seq = user.comp_seq;
    tmp_listOpt.s_addon_use_s_stu_seq = user.user_seq;
    if (strFunc.is_empty(tmp_listOpt.s_mcomp_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  const go_add_use_by_ajax = (inData: any) => {
    let opt_obj: any = {
      inside_seq_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.inside_seq_arr)) {
      alert("선택이 필요합니다.");
      return false;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let new_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
    let add_use_row_arr: any = [];
    for (let i = 0; i < opt_obj.inside_seq_arr.length; i++) {
      let inside_seq = opt_obj.inside_seq_arr[i];
      if (strFunc.is_empty(inside_seq)) {
        continue;
      }
      let add_use_row: any = {
        a_in_seq: inside_seq,
        a_stu_mcomp_seq: user.comp_seq,
        a_stu_seq: user.user_seq,
        a_stu_name: user.user_name,
        a_reserve_date: new_date_str,
        a_start_date: new_date_str,
        a_re_start_date: new_date_str,
      };
      add_use_row_arr.push(add_use_row);
    }
    if (add_use_row_arr.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    }

    if (confirm("학습 추가를 진행하시겠습니까?") == false) {
      return false;
    }

    let form_json_data: any = {
      data_arr: add_use_row_arr,
      is_default_val: "1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_use/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("학습 추가가 완료되었습니다.");
          navigate("/comp_stu/plan/word_inside/use_list");
        } else {
          alert("학습 추가 중 오류가 발생하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div style={{ width: "98%", margin: "0 auto", padding: "5px" }}>
      <div className="text-right mt-1">
        <span style={{ position: "absolute", left: 0 }}>
          학습찾기
        </span>
        <button
          className="btn btn-sky"
          onClick={() => {
            navigate("/comp_stu/plan/word_inside/use_list");
          }}>나의학습보기</button>
      </div>
      <div className='mt-2'>
        <SearchArea
          list={list}
          get_pre_use_arr_by_ajax={get_pre_use_arr_by_ajax}
          listOpt={listOpt}
          is_show_pre_exist={is_show_pre_exist}
          set_is_show_pre_exist={set_is_show_pre_exist}
        ></SearchArea>
      </div>
      <div>
        <ListArea
          infoArr={infoArr}
          go_add_use_by_ajax={go_add_use_by_ajax}
        ></ListArea>
      </div>
      <div className='mt-1'>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          is_view_num_per_page={true}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      </div>
    </div>
  );
};
export default WordInsideReqListArea;